<template>
  <div class="sr-nav" v-loading="loading">
    <ul class="ul">
      <li v-for="item in navData">
        <span :class="[{'is-link': item.isLink}, 'link']" @mouseenter="navMouseover(item)" @mouseleave="navMouseout" @click="goMenu(item.href)">{{item.name}}</span>
      </li>
    </ul>
    <transition name="fade">
      <div class="dropdown-menu" v-show="visible" @mouseenter="navMouseovers" @mouseleave="navMouseout">
        <div class="container">
          <div class="list">
            <template v-for="(item, index) in menuData">
              <dl v-if="index < 4" :style="{width: item.width ? item.width : ''}">
                <dt>{{item.name}}</dt>
                <dd v-for="i in item.children">
                  <span @click="goList(i.linkType, i.wechatProductCategories)" v-if="i.linkType === 0">{{i.name}}</span>
                  <span @click="goList(i.linkType, i.wechatLinkUrl)" v-if="i.linkType === 1">{{i.name}}</span>
                  <span @click="goList(i.linkType, i.href)" v-if="i.linkType === 'restaurant'">{{i.name}}</span>
                </dd>
              </dl>
            </template>
          </div>
          <div class="ad-container">
            <sr-ad :ad="ad"></sr-ad>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fadeS">
      <div class="wool-glass" v-show="visible"></div>
    </transition>
  </div>
</template>

<script>
  import axios from 'axios'
  import SrAd from './ad'
  export default {
    components: {
      SrAd
    },
    data () {
      return {
        loading: true,
        navFormat: {
          one: [],
          two: [],
          three: []
        },
        navData: [],
        menuData: [],
        visible: false,
        timeout: null,
        showTimeout: 250,
        hideTimeout: 150,
        ad: ''
      }
    },
    methods: {
      getRestaurant () {
        axios.post('/node/api/restaurant', {
          pageNum: 1,
          pageSize: 10,
          xCoord: 38.8,
          yCoord: 116
        }).then(res => {
          if (res.data.code === 9999) {
            let list = []
            res.data.data.forEach(arr => {
              list.push({
                linkType: 'restaurant',
                name: arr.storeName,
                href: '/restaurant-detail/' + arr.storeSysno
              })
            })
            this.navData.push({
              isLink: false,
              id: 'canyin',
              name: '餐饮',
              children: [{
                name: '地域',
                children: [{
                  linkType: 'restaurant',
                  name: '北京',
                  href: '/restaurant'
                }]
              },
              {
                width: '300px',
                name: '餐厅',
                children: list
              }]
            })
            this.loading = false
          }
        })
      },
      getECCategory () {
        axios.post('/api/ECCategory/getECCategory').then(res => {
          if (res.data.code === 9999) {
            res.data.data.categoryList.forEach(arr => {
              if (arr.level === 1 && arr.id !== 300 && arr.id !== 351) {
                this.navFormat.one.push(arr)
              } else if (arr.level === 2) {
                this.navFormat.two.push(arr)
              } else if (arr.level === 3) {
                this.navFormat.three.push(arr)
              }
            })
            this.levelOne()
            this.navData.push({isLink: false, name: '豪车', href: '/car'}, {isLink: false, name: '出行', href: '/travel'})
            this.getRestaurant()
          }
        })
      },
      levelOne () {
        this.navFormat.one.forEach((one, oneIndex) => {
          this.navData.push({
            isLink: false,
            id: one.id,
            name: one.name,
            children: []
          })
          this.levelTwo(one, oneIndex)
        })
      },
      levelTwo (one, oneIndex) {
        var twoIndex = 0
        this.navFormat.two.forEach((two) => {
          if (one.id === two.parentId) {
            this.navData[oneIndex].children.push({
              id: two.id,
              name: two.name,
              children: []
            })
            this.levelThree(two, oneIndex, twoIndex)
            twoIndex++
          }
        })
      },
      levelThree (two, oneIndex, twoIndex) {
        this.navFormat.three.forEach((three) => {
          if (two.id === three.parentId) {
            this.navData[oneIndex].children[twoIndex].children.push({
              linkType: three.linkType,
              name: three.name,
              wechatProductCategories: three.wechatProductCategories,
              wechatLinkUrl: three.wechatLinkUrl
            })
          }
        })
      },
      navMouseover (item) {
        if (item && !item.children) {
          return
        }
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.cleaerLink()
          if (item) {
            item.isLink = true
          }
          this.visible = true
          this.menuData = item.children
          this.ad = item.id
        }, this.showTimeout)
      },
      navMouseovers () {
        this.visible = true
        clearTimeout(this.timeout)
      },
      navMouseout (item) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.cleaerLink()
        }, this.hideTimeout)
      },
      cleaerLink () {
        this.navData.forEach(arr => {
          arr.isLink = false
        })
        this.visible = false
      },
      goList (type, v) {
        this.visible = false
        if (type === 0) {
          this.$router.push({
            path: '/list/category',
            query: {
              id: v
            }
          })
        } else if (type === 1) {
          this.$router.push({
            path: '/list/brand',
            query: {
              id: v.split('brandId=')[1]
            }
          })
        } else if (type === 'restaurant') {
          this.$router.push({
            path: v
          })
        }
      },
      goMenu (v) {
        if (v) {
          this.$router.push(v)
        }
      }
    },
    created () {
      this.getECCategory()
    }
  }
</script>

<style lang="less" scoped>
  .sr-nav {
    position: relative;
    z-index: 2;
    height: 50px;
    .ul {
      text-align: center;
      background: white;
      position: relative;
      z-index: 2;
      box-shadow: 0 0 12px rgba(0,0,0,.2);
      li {
        display: inline-block;
        .link {
          display: inline-block;
          line-height: 50px;
          padding: 0 34px;
          transition: all .2s;
          cursor: pointer;
          &:hover {
            color: #ccac66;
          }
        }
        .is-link {
          color: #ccac66;
        }
      }
    }
    .dropdown-menu {
      position: absolute;
      top: 100%;
      right: 0;
      left: 0;
      min-height: 430px;
      background: white;
      opacity: 1;
      transform: translate3d(0, 0, 0);
      .container {
        width: 900px;
        margin: 0 auto;
        padding-bottom: 30px;
        overflow: hidden;
        .list {
          float: left;
          width: 560px;
          dl {
            float: left;
            width: 130px;
            margin-right: 10px;
            line-height: 1.4;
          }
          dt {
            padding: 30px 0 10px;
            font-weight: bold;
          }
          dd {
            padding: 6px 0;
            font-size: 12px;
            word-break:break-all;
            span:hover {
              color: #ccac66;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }
        .ad-container {
          float: right;
          width: 340px;
          padding-top: 30px;
        }
      }
    }
    .fade-enter-active {
      transition: all .2s
    }
    .fade-leave-active {
      transition: all 0s
    }
    .fade-enter, .fade-leave-to{
      opacity: 0;
    }
    .fade-enter {
      transform: translate3d(0, -50px, 0);
    }
    .wool-glass {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      background: rgba(0,0,0,.5);
      opacity: 1;
    }
    .fadeS-enter-active, .fadeS-leave-active {
      transition: all .4s
    }
    .fadeS-enter, .fadeS-leave-to {
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/nav.vue